import axios from 'axios';

const initLoginInfo = {
  access_token: '',
  expires_in: 0,
  token_type: '',
  record_time: 0,
  refresh_ttl: 0,
}

const loginInfo = {
  state: {
    ...initLoginInfo,
  },

  reducers: {
    saveLoginInfo(state, payload) {
      const loginInfo = {
        ...payload,
        record_time: payload.record_time || Date.now(),
      }

      localStorage.setItem('user:loginInfo', JSON.stringify(loginInfo))
      axios.defaults.headers.common['Authorization'] = `Bearer ${payload.access_token}`;

      return {
        ...state,
        ...loginInfo,
      }
    },

    updateToken(state, token) {
      const loginInfo = {
        ...state.loginInfo,
      }
      
      loginInfo.access_token = token.replace('Bearer ', '');
      loginInfo.record_time = Date.now();
      localStorage.setItem('user:loginInfo', JSON.stringify(loginInfo))
      axios.defaults.headers.common['Authorization'] = `Bearer ${loginInfo.access_token}`;

      return {
        ...state,
        ...loginInfo
      }
    },

    clearLoginInfo(state) {
      axios.defaults.headers.common['Authorization'] = '';
      localStorage.removeItem('user:loginInfo');

      return {
        ...state,
        ...initLoginInfo
      }
    },
  },

  effects: (dispatch) => ({
    async logout() {
      await axios.post('auth/logout');
      dispatch.userInfo.clearUserInfo();
      dispatch.loginInfo.clearLoginInfo();
      window.location.hash='/'
    },
  })
}

export {
  initLoginInfo,
}

export default loginInfo;
